import request from "./client";

export type TenantRecord = {
  id: number;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone?: string | null;
  date_of_birth?: string | null;
  national_insurance_number?: string | null;
  emergency_contact_name?: string | null;
  emergency_contact_phone?: string | null;
  notes?: string | null;
  archived?: boolean | null;
  created_at?: string;
};

export async function getTenants() {
  return request<TenantRecord[]>("/api/tenants");
}

export async function createTenant(payload: Record<string, unknown>) {
  return request<TenantRecord>("/api/tenants", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTenant(
  id: number,
  payload: Record<string, unknown>,
) {
  return request<TenantRecord>(`/api/tenants/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteTenant(id: number) {
  return request<{ success: boolean }>(`/api/tenants/${id}`, {
    method: "DELETE",
  });
}
